import React from "react";


import Logo from "assets/logo.png";
import LogoEnglish from "assets/logoON.png";
import { useDomain } from "context/DomainContext";
import { useOptionContext } from "context/OptionContext";
import { useTheme } from "context/ThemeContext";
import { useCurrentUser } from "context/UserContext";
import { t } from "i18next";
import { FiMoon, FiSun } from "react-icons/fi";
import { Link } from "react-router-dom";
import { Province } from "types/canvasTypes";
import "./Header.css";

const Header: React.FC = () => {
  const { province } = useOptionContext();
  const { currentUser, signIn } = useCurrentUser();
  const { isReseller } = useDomain();
  const { theme, toggleTheme } = useTheme();

  return (
    <nav className="navbar" role="navigation" aria-label="Main navigation">
      <div className="navbar-container">
        <Link className="navbar-logo" to="/" aria-label="Go to home page">
          <img
            src={isReseller || province === Province.Ontario ? LogoEnglish : Logo}
            alt="Company logo"
            className="navbar-logo-img"
          />
        </Link>

        {!isReseller && province === Province.Quebec && (
          <div className="navbar-brand">
            <a
              href="https://cloture-verre.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="navbar-brand-link"
            >
              cloture-verre.com
            </a>
          </div>
        )}

        <div className="navbar-actions">
          <button
            className="theme-toggle"
            onClick={toggleTheme}
            aria-label={theme === "light" ? "Switch to dark mode" : "Switch to light mode"}
          >
            {theme === "light" ? <FiMoon size={18} /> : <FiSun size={18} />}
          </button>

          {currentUser?.photoURL && (
            <img
              src={currentUser.photoURL}
              alt={`${currentUser.displayName || 'User'} profile`}
              className="navbar-user-photo"
            />
          )}

          {currentUser?.displayName && (
            <span className="navbar-user-greeting">
              Hi {currentUser.displayName}
            </span>
          )}

          {!currentUser && (
            <button 
              className="nav-login-button" 
              onClick={signIn}
              aria-label="Sign in with Google"
            >
              Google Login
            </button>
          )}

          <Link to="/changelog" className="navbar-link">
            {t("changelog")}
          </Link>

          <a 
            href={isReseller ? "https://glass-railing.com" : t("aboutWebsite")} 
            target="_blank" 
            rel="noopener noreferrer"
            className="navbar-link"
          >
            {t("about")}
          </a>

          <a 
            href={isReseller ? "https://glass-railing.com/contact" : t("contactWebsite")} 
            target="_blank" 
            rel="noopener noreferrer"
            className="navbar-link"
          >
            {t("contact")}
          </a>
        </div>
      </div>
    </nav>
  );
};

export default Header;
